import type {
  ServiceToolbarAction,
} from 'views/EMR/components/ServiceLookup/ServiceToolbar';
import type {
  ToolbarAction,
} from 'views/EMR/components/TextAreaToolbar';

export const fieldChangedCSS = 'border-2 border-blue-500 rounded-lg';

export const visitNoteEditorActions: ToolbarAction[] = [
  'dictation',
  'salt',
  'template',
  'field',
];

export const visitNoteAdditionalAssessmentActions: ToolbarAction[] = [
  'dictation',
  'salt',
  'field',
];

export const visitNoteBillingActions: ServiceToolbarAction[] = [
  'ai',
  'pin',
  'salt',
];

export const visitNoteCustomServiceActions: ServiceToolbarAction[] = [
  'pin',
  'salt',
];

export const assessmentLookupClasses = {
  root: 'w-100 pb-2 nw-assessment-codes',
  table: 'w-[600px]',
} as const;

export const billingLookupClasses = {
  root: 'w-120 pb-2 nw-billing-codes',
  table: 'w-[600px]',
} as const;

export const customServiceLookupClasses = {
  root: 'w-100 pb-2',
  table: 'w-[400px]',
} as const;

export const serviceCodesFormKeys = {
  CPTCode: 'bill.serviceCodes',
  ICDCode: 'bill.assessmentCodes',
} as const;
